// src/services/GradesService.js
import http from './Http';

const listarAreasPorNivel = (nivelId) => {
  return http.get(`/areas/nivel/${nivelId}`);
};

const listarAreasPorGrado = (gradoId) => {
  return http.get(`/grados/${gradoId}/areas`);
};


const obtenerGrado = (gradoId) => {
  return http.get(`/grados/${gradoId}`);
};

const GradoService = {
  listarAreasPorNivel,
  listarAreasPorGrado,
  obtenerGrado
};

export default GradoService;
